// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/ABSDescription/index.less
// module id = 1366
// module chunks = 42